import React, { useState, useEffect } from 'react';
import FormComponent from '../../../Reusable_Components/FormComponent';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/apiConfig';
import { useParams } from 'react-router-dom';

const AssetInput = () => {
  const { assetId = '' } = useParams();
  const decodedId = assetId ? atob(assetId) : assetId;
  const id = decodedId.replace(/\D/g, '');

  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const route = 'asset';

  useEffect(() => {
    if (assetId) {
      setIsEditing(true);
      fetchAssetDetails();
    }
  }, [assetId]);

  const fetchAssetDetails = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.asset}${id}/`, { headers });
      const assetDetails = response.data;

      setFormData(assetDetails);
    } catch (error) {
      console.error('Error fetching asset details:', error);
    }
  };

  const assetFields = [
    { name: 'name', label: 'Asset Name', type: 'text' },
    {
      name: 'purchase_date',
      label: 'Purchase Date',
      type: 'date',
    },
    {
      name: 'purchase_price',
      label: 'Purchase Price',
      type: 'number',
    },
    {
      name: 'useful_life_years',
      label: 'Useful Life Years',
      type: 'number',
    },
    {
      name: 'depreciation_rate',
      label: 'Depreciation Rate',
      type: 'number',
    },
    {
      name: 'current_value',
      label: 'Current Value',
      type: 'number',
    },
    {
      name: 'asset_type',
      label: 'Asset Type',
      type: 'select',
      options: [
        { value: 'FIXED', label: 'Fixed' },
        { value: 'CURRENT', label: 'Current' },
      ],
    },
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Asset' : 'Create Asset'}</h1>
      <FormComponent fields={assetFields} initialFormData={formData} route={route} />
    </div>
  );
};

export default AssetInput;